/** 与后端 VerificationResendRateLimiter 对齐 */
export const RESEND_COOLDOWN_SEC = 60;
export const RESEND_MAX_PER_HOUR = 5;

const STORAGE_PREFIX = 'aivideoclip_resend_';

function storageKey(email) {
  return STORAGE_PREFIX + String(email || '').trim().toLowerCase();
}

export function getResendCooldownRemainingSec(email) {
  try {
    const raw = localStorage.getItem(storageKey(email));
    if (!raw) return 0;
    const last = Number(raw);
    if (!Number.isFinite(last)) return 0;
    const elapsed = Math.floor((Date.now() - last) / 1000);
    return Math.max(0, RESEND_COOLDOWN_SEC - elapsed);
  } catch (e) {
    return 0;
  }
}

export function markResendSent(email) {
  try {
    localStorage.setItem(storageKey(email), String(Date.now()));
  } catch (e) {
    // ignore
  }
}
